exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container---3r1a_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 100%; }\n\n.children---1UMph {\n  padding-right: 6px; }\n\n.label---1i3KQ {\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 600; }\n\n.forwardButton---3Tqwl {\n  width: 19px;\n  height: 19px; }\n\n.forwardButton---3Tqwl svg path {\n    fill: white !important; }\n\n.disabled---3IwVs {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"container": "container---3r1a_",
	"children": "children---1UMph",
	"label": "label---1i3KQ",
	"forwardButton": "forwardButton---3Tqwl",
	"disabled": "disabled---3IwVs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/course-badge-admin/index.scss
// module id = 1152
// module chunks = 3